import { render, staticRenderFns } from "./brandManagerment.vue?vue&type=template&id=25971efc&scoped=true&"
import script from "./brandManagerment.vue?vue&type=script&lang=js&"
export * from "./brandManagerment.vue?vue&type=script&lang=js&"
import style0 from "./brandManagerment.vue?vue&type=style&index=0&id=25971efc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25971efc",
  null
  
)

component.options.__file = "brandManagerment.vue"
export default component.exports